import { trimJoinedStringWhitespace } from '../../core/util';
import { maskSsnForDisplay } from '../PersonalInformationSection/util';

export const extractPhoneNumber = phones => {
  if (phones && phones.length > 0) {
    const { areaCode, exchange, lastFour } = phones[0];
    return [areaCode, exchange, lastFour].filter(Boolean).join('-') || '';
  }

  return '';
};

export const customerSummaryLine1 = customer => {
  const { name, residentialAddress } = customer || {};

  const { firstName, middleName = '', lastName } = name || {};
  const { street1, street2, zip, city, state } = residentialAddress || {};

  const fullName = [firstName, middleName, lastName].join(' ');

  return [
    trimJoinedStringWhitespace(fullName),
    street1,
    street2,
    city,
    state,
    zip
  ]
    .filter(item => item)
    .join(' / ');
};

export const customerSummaryLine2 = customer => {
  const { primaryEmailAddress: emailAddress, phones } = customer || {};

  const phoneNumber = extractPhoneNumber(phones);

  return [emailAddress, phoneNumber].filter(item => item).join(' / ');
};

export const customerSummaryLine3 = customer => {
  const { citizenship, taxID, dob } = customer || {};

  return [
    dob,
    {
      US_CITIZEN: 'U.S. Citizen',
      RESIDENT_ALIEN: 'U.S. Resident Alien'
    }[citizenship] || citizenship,
    maskSsnForDisplay(taxID)
  ]
    .filter(item => item)
    .join(' / ');
};
